import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import { Outlet } from 'react-router-dom';
import { Toast } from '@heroui/react';
import { AriaRouter } from './router/AriaRouter';
import './i18n';
import { Layout } from './layout';
import { ApiProvider } from './api';
import { clearAuthSession, getAccessToken } from './utils';
import { env } from './config/env';

dayjs.extend(utc);
dayjs.extend(advancedFormat);

/**
 * The API this bundle was built for: the mode's env file sets
 * `BUN_PUBLIC_API_BASE_URL` and the build inlines it (BOS-236, `config/env`).
 */
const API_BASE_URL = env.apiBaseUrl;

export const App: React.FC = () => {
    return (
        // Wired here rather than in `frontend.tsx` because it depends on
        // react-router hooks and this component is the router's root element.
        // It is what makes an `href` on a React Aria component a working link
        // — see `AriaRouter`.
        <AriaRouter>
            <ApiProvider
                baseUrl={API_BASE_URL}
                getAccessToken={getAccessToken}
                removeAccessToken={clearAuthSession}
            >
                <Layout>
                    <Outlet />
                </Layout>
                {/* Action results (rulebook §5.5): `toast` from
                    `@heroui/react` renders here, on every page, the
                    full-screen ones included. At the top: the app's sticky
                    bottom bars (the catalog import's action bar, the form
                    drawer's footer) hold the next action, and a toast at
                    the bottom covered their buttons on a phone. */}
                <Toast.Provider placement="top" />
            </ApiProvider>
        </AriaRouter>
    );
};
